import { Combo } from 'types/combo';
import { Controller, useFormContext } from 'react-hook-form';
import Select, { createFilter } from 'react-select';
import { useEffect } from 'react';
import { useMaterialUIController } from 'context';
import { useTranslation } from 'react-i18next';

type SelectAutoCompProps = {
    options: Combo[];
    defaultValue?: number;
    onChange?: (value: Combo['value'] | null) => void;
    value?: number | string | void;
    name: string;
    backgroundColor?: string;
    placeholder?: string;
    disabled?: boolean;
    autoFocus?: boolean;
    /// Acompanha o TextField do mesmo size: small ao lado de campos small.
    size?: 'small' | 'medium';
};

/// Mesma conta do inputSizeSmall do tema: fonte xs × line-height do MUI + 10px de padding vertical.
const SMALL = { height: 'calc(0.75rem * 1.4375 + 1.25rem)', fontSize: '0.75rem' };
const MEDIUM = { height: '43px', fontSize: '14px' };

const AutoCompleteSelect = (props: SelectAutoCompProps) => {
    const { t } = useTranslation();
    const { control, setValue, watch } = useFormContext();
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const sizing = props.size === 'small' ? SMALL : MEDIUM;

    useEffect(() => {
        console.log(props.name);
    }, [watch(props.name)]);

    useEffect(() => {
        console.log(props.disabled);
    }, [props.disabled]);

    return (
        <Controller
            control={control}
            name={props.name}
            render={({ field }) => {
                return (
                    <Select
                        autoFocus={props.autoFocus}
                        menuPortalTarget={document.body} 
                        menuPosition="fixed"
                        defaultValue={props.options.find((x) => x.value === props.defaultValue)}
                        options={props.options}
                        filterOption={createFilter({ stringify: (option) => option.label })}
                        // menuIsOpen={true}
                        onChange={(option) => {
                            field.onChange(option ? option.value : null);
                            props.onChange ? props.onChange(option ? option.value : null) : '';
                            setValue(props.name, option ? option.value : null);
                        }}
                        value={
                            props.options.find((option) => option.value === field.value) ||
                            null
                        }
                        placeholder={props.placeholder || t('general.selecione')}
                        isDisabled={props.disabled}
                        styles={{
                            control: (base) => ({
                                ...base,
                                background: 'transparent',
                                border: props.disabled
                                    ? darkMode
                                        ? '1px solid #405568'
                                        : '1px solid #AAAAAA'
                                    : darkMode
                                    ? '1px solid #405568'
                                    : 'lightgray solid 1px',
                                borderRadius: '5px',
                                minWidth: '155px',
                                height: sizing.height,
                                minHeight: sizing.height,
                                color: darkMode ? '#ffffff' : '#000000',
                                cursor: props.disabled ? "not-allowed" : "default",
                            }),
                            placeholder: (base) => ({
                                ...base,
                                fontSize: sizing.fontSize,
                                color: darkMode ? '#b8c5d1' : '#6c757d',
                            }),
                            singleValue: (base) => ({
                                ...base,
                                fontSize: sizing.fontSize,
                                color: darkMode ? (props.disabled ? 'rgba(255, 255, 255, 0.45)' : '#ffffff') : (props.disabled ? 'rgba(0, 0, 0, 0.45)' : '#000000'),
                            }),
                            indicatorsContainer: (base) => ({
                                ...base,
                                ...(props.size === 'small' && { height: '100%', paddingTop: 0, paddingBottom: 0 }),
                            }),
                            valueContainer: (base) => ({
                                ...base,
                                ...(props.size === 'small' && { height: '100%', paddingTop: 0, paddingBottom: 0 }),
                            }),
                            menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999,
                            }),
                            menu: (base) => ({
                                ...base,
                                fontSize: '14px',
                                backgroundColor: darkMode ? '#1b2536' : '#FFFFFF',
                                color: darkMode ? '#ffffff' : '#000',
                                zIndex: 9999,
                            }),
                            option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isFocused
                                    ? darkMode
                                        ? '#26324a'
                                        : '#e9ecef'
                                    : darkMode
                                    ? '#1b2536'
                                    : '#FFFFFF',
                                color: darkMode ? '#ffffff' : '#000000',
                                ':hover': {
                                    backgroundColor: darkMode ? '#26324a' : '#e9ecef',
                                },
                            }),
                            input: (base) => ({
                                ...base,
                                fontSize: sizing.fontSize,
                                color: darkMode ? '#ffffff' : '#000000',
                            }),
                        }}
                    />
                );
            }}
        />
    );
};

export default AutoCompleteSelect;
